import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function ArticulosPlasticosCreate() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_MOLDES = process.env.REACT_APP_URL_MOLDES_INYECCION;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [moldes, setMoldes] = useState([]);
  const [colores, setColores] = useState([]);
  const [coloresSel, setColoresSel] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [categoriaSel, setCategoriaSel] = useState("");
  const [capacidad, setCapacidad] = useState("");
  const [piezasPorPaquete, setPiezasPorPaquete] = useState(0);
  const [descripcion, setDescripcion] = useState("");
  const [codigo, setCodigo] = useState("");
  const [tipoArticulo, setTipoArticulo] = useState("Fabricacion");
  const [cavidades, setCavidades] = useState(1);
  const [minimo, setMinimo] = useState(0);
  const [maximo, setMaximo] = useState(0);
  const [moldeInyeccion, setMoldeInyeccion] = useState("");
  const [costo, setCosto] = useState(0);
  const [codigoSAT, setCodigoSAT] = useState("");
  const [codigoUnidad, setCodigoUnidad] = useState("PZ");
  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios.get(URL_MOLDES, headers).then((r) => setMoldes(r.data)).catch((e) => console.log(e));
    axios.get(URL_COLORES, headers).then((r) => setColores(r.data)).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_CRM_CATEGORIAS, headers).then((r) => setCategorias(r.data)).catch((e) => console.log(e));
  }, []);

  function toggleColor(id) {
    setColoresSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  const save = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    const body = {
      fecha: new Date().toISOString().split("T")[0],
      descripcion,
      costo: Number(costo) || 0,
      tipo_articulo: tipoArticulo,
      cavidades: Number(cavidades) || 1,
      minimo: Number(minimo) || 0,
      maximo: Number(maximo) || 0,
      colores: coloresSel,
      categorias: categoriaSel ? [categoriaSel] : [],
      capacidad: capacidad || "NA",
      piezasPorPaquete: Number(piezasPorPaquete) || 0,
      tallas: [],
    };
    if (codigo) body.codigo = codigo;
    if (codigoSAT) body.codigoSAT = codigoSAT;
    if (codigoUnidad) body.codigoUnidad = codigoUnidad;
    if (tipoArticulo === "Fabricacion" && moldeInyeccion) body.moldeInyeccion = [moldeInyeccion];

    axios.post(URL_ARTICULOS, body, headers)
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Crear Articulo", detalle: descripcion, user: user.id }, headers);
        Swal.fire("Good job!", "Artículo creado con éxito", "success");
        setTimeout(() => { window.location.href = "/ListadoArticulos"; }, 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? JSON.stringify(error.response.data) : error}` });
      });
  };

  return (
    <>
      <Header />
      <br />
      <div className="container">
        <div className="card col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-wine-bottle" style={{ marginRight: 8, color: "#0ea5e9" }} />
                Nuevo Artículo
              </h3>
              <p className="page-subtitle">Botella u otro producto (plásticos)</p>
            </div>
          </div>
          <Form onSubmit={save}>

            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-wine-bottle" />
                <span className="form-section-title">Plásticos</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={3}>
                    <Label>Tipo de artículo</Label>
                    <Input type="select" value={tipoArticulo} onChange={(e) => setTipoArticulo(e.target.value)}>
                      <option value="Fabricacion">Fabricación (se produce)</option>
                      <option value="Comercial">Comercializacion (se compra/revende)</option>
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Label>Cavidades</Label>
                    <Input type="number" value={cavidades} onChange={(e) => setCavidades(e.target.value)} />
                  </Col>
                  <Col md={2}>
                    <Label>Mínimo inv.</Label>
                    <Input type="number" value={minimo} onChange={(e) => setMinimo(e.target.value)} />
                  </Col>
                  <Col md={2}>
                    <Label>Máximo inv.</Label>
                    <Input type="number" value={maximo} onChange={(e) => setMaximo(e.target.value)} />
                  </Col>
                  {tipoArticulo === "Fabricacion" && (
                    <Col md={5}>
                      <Label>Molde de Inyección</Label>
                      <Input type="select" value={moldeInyeccion} onChange={(e) => setMoldeInyeccion(e.target.value)}>
                        <option value="">Sin asignar</option>
                        {moldes.map((m) => <option key={m._id} value={m._id}>{m.nombre}</option>)}
                      </Input>
                    </Col>
                  )}
                  <Col md={6}>
                    <Label>Familia / Categoría</Label>
                    <Input type="select" value={categoriaSel} onChange={(e) => setCategoriaSel(e.target.value)}>
                      <option value="">Sin asignar</option>
                      {categorias
                        .filter((c) => c.is_active !== "No")
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((c) => <option key={c._id} value={c._id}>{c.nombre}</option>)}
                    </Input>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={3}>
                    <Label>Capacidad</Label>
                    <Input type="text" placeholder="Ej. 1000ML" value={capacidad} onChange={(e) => setCapacidad(e.target.value)} />
                  </Col>
                  <Col md={3}>
                    <Label>Piezas por paquete</Label>
                    <Input type="number" value={piezasPorPaquete} onChange={(e) => setPiezasPorPaquete(e.target.value)} />
                  </Col>
                </Row>
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-tshirt" />
                <span className="form-section-title">Datos del Modelo</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={3}>
                    <Label>Codigo</Label>
                    <Input type="text" placeholder="Codigo" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
                  </Col>
                  <Col md={3}>
                    <Label>Descripcion *</Label>
                    <Input type="text" placeholder="Descripcion" value={descripcion} required onChange={(e) => setDescripcion(e.target.value)} />
                  </Col>
                  <Col md={3}>
                    <Label>Codigo SAT</Label>
                    <Input type="select" placeholder="CodigoSAT" value={codigoSAT} onChange={(e) => setCodigoSAT(e.target.value)}>
                      <option value="">Selecciona</option>
                      <option value="NA">NA</option>
                      <option value="53101604">53101604</option>
                      <option value="53102002">53102002</option>
                      <option value="53101504">53101504</option>
                      <option value="53101804">53101804</option>
                      <option value="53101704">53101704</option>
                      <option value="53103100">53103100</option>
                      <option value="53102800">53102800</option>
                      <option value="1010101">1010101</option>
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label>Codigo Unidad</Label>
                    <Input type="text" placeholder="CodigoUnidad" value={codigoUnidad} onChange={(e) => setCodigoUnidad(e.target.value)} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={3}>
                    <Label>Costo</Label>
                    <Input type="number" value={costo} onChange={(e) => setCosto(e.target.value)} />
                  </Col>
                </Row>
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-palette" />
                <span className="form-section-title">Colores</span>
              </div>
              <div className="form-section-body">
                <div style={{ maxHeight: 160, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 8 }}>
                  {colores.length === 0 ? (
                    <small className="text-muted">No hay colores. Créalos en Catálogos → Colores.</small>
                  ) : (
                    colores
                      .filter((c) => c.is_active !== "No")
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((c) => (
                        <div key={c._id} style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "2px 12px 2px 0" }}>
                          <input
                            type="checkbox"
                            checked={coloresSel.includes(c._id)}
                            onChange={() => toggleColor(c._id)}
                          />
                          <span>{c.name}</span>
                        </div>
                      ))
                  )}
                </div>
              </div>
            </div>

            <div className="submit-bar">
              <Button href="/ListadoArticulos" className="btn btn-danger" id="botonListado">
                Regresar
              </Button>
              <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}

export default ArticulosPlasticosCreate;
